import { propEq } from 'ramda';

import { type RemoteTimezone } from '@/lib/utils/dates';

export type DatoTimeZone = {
  abbreviation: string;
  name: string;
  standardId: RemoteTimezone;
};

export const getCopyForTimeZone = (
  timeZoneId: RemoteTimezone,
  timeZones: DatoTimeZone[]
): DatoTimeZone | undefined => timeZones.find(propEq('standardId', timeZoneId));
